module.exports = __webpack_public_path__ + "static/media/skule.864d1d04.jpg";